import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { ConfigService } from '@shared-data-access';

// Función para cargar configuración con reintentos y fallback
async function loadAppConfig() {
  try {
    // Construimos la URL absoluta.
    // Como los archivos están en /public, el servidor los sirve en la RAÍZ (/).
    const configUrl = new URL('config.json', window.location.origin).href;
    console.log('Intentando cargar config desde:', configUrl);

    const response = await fetch(configUrl, { cache: 'no-cache' });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const config = await response.json();
    (window as any)['__APP_CONFIG__'] = config;
    console.log('✅ Config cargada exitosamente:', config.environmentName);
  } catch (error) {
    console.error('❌ Error cargando assets/config.json:', error);
    // Fallback: Si estamos en desarrollo local, usamos valores por defecto
    // Esto permite trabajar aunque el archivo no se sirva correctamente
    const isLocal =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';

    (window as any)['__APP_CONFIG__'] = {
      apiUrl: isLocal ? 'http://localhost:8080' : 'https://api.argenper.com',
      environmentName: isLocal ? 'local-fallback' : 'prod-fallback',
      systems: isLocal
        ? [
            {
              name: 'Admin Central',
              url: '/app/dashboard',
              permission: 'system:admin',
            },
          ]
        : [],
    };
    console.warn(
      'Usando configuración de fallback. ¿Está config.json en /assets/?',
    );
  } finally {
    // Siempre arrancamos la app, aunque sea con fallback
    return bootstrapApplication(App, appConfig);
  }
}

// Ejecutamos la carga
loadAppConfig();
